import { render, staticRenderFns } from "./productHead.vue?vue&type=template&id=da97f3f6&scoped=true"
import script from "./productHead.vue?vue&type=script&lang=js"
export * from "./productHead.vue?vue&type=script&lang=js"
import style0 from "./productHead.vue?vue&type=style&index=0&id=da97f3f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da97f3f6",
  null
  
)

export default component.exports